<template>
  <li :class="classes">
    <span
      v-if="item.placeholder && !processing && !filled && editable"
      class="former-section-file-placeholder"
    >
      <img
        alt=""
        class="former-section-file-placeholder-image"
        :src="cnhGuide"
      >

      <p>
        <b class="former-section-file-placeholder-title">Dica!</b>
        {{ item.placeholder }}
      </p>
    </span>

    <span class="former-section-file-label">
      <span class="former-section-file-ball">
        <span
          v-if="processing"
          class="former-section-file-bar"
          :style="{ height: progress }"
        />

        <font-awesome-icon
          class="form-section-file-icon"
          :icon="filled ? 'check' : 'file-image'"
        />
      </span>

      <div class="former-section-file-info">
        {{ item.label }}

        <span class="former-section-file-buttons">
          <span
            v-if="processing"
            :class="[buttonBig, 'former-section-file-progress']"
          >
            {{ progress }}
          </span>

          <template v-else>
            <a
              v-if="!editable && filled"
              :href="downloadable"
              :class="buttonBig"
              :disabled="!desktop || !downloadable"
              target="_blank"
            >
              <font-awesome-icon
                class="former-section-file-button-icon"
                icon="download"
              />

              Download
            </a>

            <label :class="editable ? buttonBig : filled ? buttonSmall : buttonBig">
              <font-awesome-icon
                v-if="!editable && filled"
                icon="pen"
              />

              <template v-else>
                {{ empty ? 'Enviar arquivo...' : 'Alterar arquivo...' }}
              </template>

              <span
                v-if="desktop"
                class="former-section-file-input"
                @click="toggle"
              />

              <input
                v-else
                class="former-section-file-input"
                :accept="item.meta.accept || 'image/*,application/pdf'"
                type="file"
                @change="change"
              >
            </label>

            <button
              v-if="filled"
              :class="buttonSmall"
              @click="remove"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </template>
        </span>
      </div>
    </span>

    <span
      v-if="item.errors.length"
      class="former-section-file-error"
    >
      {{ item.errors[0] }}
    </span>

    <popup-confirm
      v-if="removing"
      color="red"
      title="Remover arquivo"
      @close="remove"
      @confirm="removed"
    >
      Remover anexo <b>{{ item.label }}</b>?
    </popup-confirm>

    <popup-modal
      v-if="popup"
      :title="item.label"
      @close="toggle"
    >
      <template v-if="qrCode">
        <div class="former-section-file-popup">
          <p><b>Opção 1:</b> Envie um arquivo do seu computador</p>

          <label class="former-section-file-wrapper">
            <span :class="buttonBig">
              Enviar arquivo...

              <input
                class="former-section-file-input"
                :accept="item.meta.accept || 'image/*,application/pdf'"
                type="file"
                @change="change"
              >
            </span>
          </label>

          <span class="former-section-file-separator">
            <span class="former-section-file-or">
              ou
            </span>
          </span>

          <p><b>Opção 2:</b> Envie um arquivo usando seu celular ou tablet</p>

          <div class="former-section-file-wrapper">
            <qrcode-vue
              :value="remote"
              :size="200"
              background="#f7f8fa"
              class="former-section-file-qrcode"
            />

            <ol class="former-section-file-list">
              <li class="former-section-file-list-item">
                Aponte seu celular ou tablet para o código acima usando a
                câmera (se usar iPhone ou iPad) ou um aplicativo de leitura
                de QR Code (se usar Android).
              </li>

              <li class="former-section-file-list-item">
                Uma página do Credere para o envio de arquivos será aberta no
                seu aparelho. É só tirar a foto do documento e aguardar o arquivo
                ser processado pelo Credere!
              </li>
            </ol>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="former-section-file-popup">
          <p>Envie um arquivo do seu computador</p>

          <label class="former-section-file-wrapper">
            <span :class="buttonBig">
              Enviar arquivo...

              <input
                class="former-section-file-input"
                :accept="item.meta.accept || 'image/*,application/pdf'"
                type="file"
                @change="change"
              >
            </span>
          </label>
        </div>
      </template>
    </popup-modal>
  </li>
</template>

<script>
  import { mapState } from 'vuex';
  import axios from 'axios';

  import QrcodeVue from 'qrcode.vue';

  import persisted from '@/helpers/modules/auth';

  import cnhGuide from '@/assets/images/illustrations/cnh/guide-small.jpg';

  import PopupConfirm from '@/components/Popup/Confirm.vue';
  import PopupModal from '@/components/Popup/Modal.vue';

  export default {
    name: 'FormerSectionFile',
    components: {
      PopupConfirm,
      PopupModal,
      QrcodeVue,
    },
    props: {
      item: {
        type: Object,
        default() {
          return {};
        },
      },
      desktop: {
        type: Boolean,
        default: false,
      },
      editable: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        file: {},
        processing: false,
        task: null,
        progress: null,
        popup: false,
        removing: false,

        cnhGuide,
      };
    },
    computed: {
      ...mapState([
        'auth',
        'attachments',
      ]),

      id() {
        return this.item.id;
      },
      isVehicleUpload() {
        return this.item.subdomain === 'Vehicle';
      },
      classes() {
        const classes = ['former-section-file'];

        const {
          editable,
          filled,
          processing,
        } = this;

        if (!editable) {
          classes.push('former-section-file-disabled');
        }

        if (filled) {
          classes.push('former-section-file-filled');
        }

        if (processing) {
          classes.push('former-section-file-processing');
        }

        return classes;
      },
      empty() {
        return ['', null, undefined].indexOf(this.item.value) > -1;
      },
      filled() {
        return !this.empty && !this.processing;
      },

      account() {
        return this.auth.user.account.id;
      },

      downloadable() {
        console.log(this.item.value);

        const {
          id,
          key,
        } = JSON.parse(this.item.value || '{}');

        if (!id || !key || !this.desktop) {
          return false;
        }

        return `${persisted.environment.split('/api/v1')[0]}/attachments/${id}`;
      },

      remote() {
        return `${persisted.environment.split('/api/v1')[0]}${this.attachments.result.url}?l=PF&o=Customer&a=${this.account}&k=${this.item.meta.type}&s=${this.attachments.list.join(',')}`;
      },

      buttonBig() {
        const classes = ['former-section-file-button'];

        if (this.editable) {
          classes.push('former-section-file-button-editable');
        }

        return classes;
      },
      buttonSmall() {
        return [this.buttonBig, 'former-section-file-button-iconed'];
      },

      qrCode() {
        const {
          qrCode,
        } = this.item;

        return typeof qrCode === 'boolean' ? qrCode : true;
      },
    },
    watch: {
      'attachments.list': {
        handler() {
          this.$nextTick(() => {
            this.toggle(false);
          });
        },
      },
    },
    methods: {
      toggle(bool) {
        this.popup = typeof bool === 'boolean' ? bool : !this.popup;
      },
      random() {
        return 'xxx'.replace(/x/g, () => Math.random().toString(36).substr(2));
      },
      change(event) {
        this.file = {};
        const file = event.target.files && event.target.files[0];

        if (file) {
          this.file = file;

          this.upload();
          this.toggle(false);
        }
      },
      async upload() {
        const params = new URLSearchParams();

        params.append('kind', this.isVehicleUpload ? 'VEHICLE' : 'ATTACHMENT');
        params.append('model', this.isVehicleUpload ? null : 'Customer');
        params.append('type', this.file.type);
        params.append('name', this.file.name);
        params.append('account_id', this.account);

        this.uploading();
        this.processing = true;

        axios
          .post(
            `${process.env.VUE_APP_AWS_VEHICLES_UPLOADS_LAMBDA_URL}?${params.toString()}`,
            await this.read(this.file),
            { headers: { 'Content-Type': 'application/octet-stream' } },
          )
          .then(response => this.uploaded(false, response.data.data))
          .catch(error => this.uploaded(error));

        // this.task.on('httpUploadProgress', this.uploading);
      },
      read(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('Couldn\'t read the selected file as binary data'));

          reader.readAsArrayBuffer(file);
        });
      },
      uploading(data) {
        if (!data || !data.total) {
          this.progress = 'Enviando...';
        } else {
          this.progress = `${parseInt(data.loaded * 100 / data.total, 10)}%`;
        }
      },
      uploaded(error, data) {
        this.progress = null;
        this.processing = false;

        if (error) {
          // eslint-disable-next-line no-alert
          window.alert('Oops! Parece que algo deu errado.');
          console.log(error);

          return;
        }

        this.$emit('change', this.item.id, JSON.stringify({
          name: data.name,
          key: data.key,
        }));
      },

      remove() {
        this.removing = !this.removing;
      },
      removed() {
        this.removing = false;
        this.$emit('change', this.item.id, '');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-section-file {
    margin: $gutter-big 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .former-section-file-disabled {
    & + & {
      margin-top: -$gutter-small;
    }
  }

  .former-section-file-label {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    list-style: none;
  }

  .former-section-file-info {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media all and (min-width: $breakpoint-desktop) {
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;
    }
  }

  // .former-section-file-placeholder-icon,
  .former-section-file-ball {
    background-color: $blue;
    border-radius: 50%;
    color: $white;
    flex-shrink: 0;
    font-size: $font-size;
    line-height: $button-smaller;
    margin: 0 $gutter-small 0 (-$gutter-smaller);
    overflow: hidden;
    position: relative;
    text-align: center;
    width: $button-smaller;

    .former-section-file-filled & {
      background-color: $gray-light;
      color: $green;
      font-size: $font-small;
    }

    .former-section-file-processing & {
      background-color: $gray-light;
      color: $white;
    }
  }

  // .former-section-file-placeholder-icon {
  //   @mixin placeholder-icon {
  //     background-color: $green;
  //     color: $white;
  //   }

  //   @include placeholder-icon;

  //   .former-section-file-filled &,
  //   .former-section-file-processing & {
  //     @include placeholder-icon;
  //   }
  // }

  .form-section-file-icon {
    position: relative;
  }

  .former-section-file-bar {
    background-color: $green;
    bottom: 0;
    height: 0%;
    left: 0;
    position: absolute;
    transition: height .3s;
    width: 100%;
  }

  .former-section-file-buttons {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: $gutter-smallest 0 0 (-$gutter-smallest);

    @media all and (min-width: $breakpoint-desktop) {
      margin: 0 0 0 $gutter-small;
    }
  }

  .former-section-file-button {
    @include button-reset;

    background-color: $gray-light;
    border-radius: $button-smaller * 0.5;
    color: $black;
    display: block;
    line-height: $button-smaller;
    margin-right: $gutter-smallest;
    min-width: $button-smaller;
    padding: 0 $gutter;
    position: relative;
    text-align: center;
    white-space: nowrap;

    &.former-section-file-button-editable {
      background-color: $blue;
      color: $white;
    }

    .former-section-file-wrapper &,
    .former-section-file-filled & {
      background-color: $green;
      color: $white;
    }

    &[disabled],
    &.former-section-file-progress {
      background-color: $gray;
      color: $black;
      cursor: default;
    }

    &[disabled] {
      cursor: not-allowed;
    }

    &.former-section-file-button-iconed {
      font-size: $font-smaller;
      padding: 0;
    }
  }

  .former-section-file-button-icon {
    margin-right: $gutter-smallest;
  }

  .former-section-file-input {
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .former-section-file-placeholder {
    align-items: center;
    color: $green;
    display: flex;
    flex-direction: row;
    margin: -$gutter-small 0 $gutter 0;
    justify-content: flex-start;
  }

  .former-section-file-placeholder-title {
    font-weight: $bold;

    @media all and (min-width: $breakpoint-desktop) {
      display: block;
      margin-bottom: $gutter-smallest;
    }
  }

  .former-section-file-placeholder-image {
    display: block;
    height: $gutter-biggest * 2;
    margin: 0 $gutter-small 0 0;

    @media all and (min-width: $breakpoint-desktop) {
      height: $gutter-biggest + $gutter;
    }
  }

  .former-section-file-error {
    color: $red;
    display: block;
    margin: $gutter-smaller 0 0 $button-small - $gutter-small;
  }

  .former-section-file-popup {
    padding: 0 $gutter $gutter - $gutter-small;

    @media all and (min-width: $breakpoint-desktop) {
      padding: 0 $gutter-bigger $gutter-bigger - $gutter-small;
    }
  }

  .former-section-file-wrapper {
    align-items: center;
    background-color: $gray-light;
    border-radius: $button-small * 0.5;
    display: flex;
    flex-direction: column;
    margin: $gutter-small (-$gutter-small) 0;
    padding: $gutter-small;
    justify-content: center;
  }

  .former-section-file-separator {
    background-color: $gray-light;
    display: block;
    height: 1px;
    margin: $gutter-big 0;
    position: relative;
    width: 100%;
  }

  .former-section-file-or {
    background-color: $white;
    font-weight: $bold;
    left: 0;
    line-height: $button-smaller;
    margin: -$button-smaller * 0.5 auto 0;
    position: absolute;
    right: 0;
    text-align: center;
    width: $gutter-biggest;
  }

  .former-section-file-qrcode {
    background-color: $white;
    display: block;
    height: 200px;
    margin: $gutter auto;
    position: relative;
    width: 200px;
  }

  .former-section-file-list {
    margin: $gutter-smaller $gutter $gutter-smaller $gutter-bigger;
  }

  .former-section-file-list-item {
    margin-bottom: $gutter-small;
  }
</style>
